(function () {
  if (window.VibeeLightbox) return;

  var overlay = null;
  var activeIndex = 0;
  var items = [];
  var focusTrapCleanup = null;

  function lockScroll(lock) {
    document.documentElement.classList.toggle('vibee-lightbox-open', lock);
  }

  function buildOverlay() {
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'vibee-lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.hidden = true;
    overlay.innerHTML =
      '<div class="vibee-lightbox__backdrop" data-vibee-lightbox-close></div>' +
      '<button type="button" class="vibee-lightbox__close" data-vibee-lightbox-close aria-label="Close">' +
      '<span aria-hidden="true">&times;</span></button>' +
      '<button type="button" class="vibee-lightbox__nav vibee-lightbox__nav--prev" data-vibee-lightbox-prev aria-label="Previous">' +
      '<span aria-hidden="true">&#8249;</span></button>' +
      '<button type="button" class="vibee-lightbox__nav vibee-lightbox__nav--next" data-vibee-lightbox-next aria-label="Next">' +
      '<span aria-hidden="true">&#8250;</span></button>' +
      '<div class="vibee-lightbox__stage">' +
      '<img class="vibee-lightbox__image" alt="" />' +
      '</div>' +
      '<p class="vibee-lightbox__counter" data-vibee-lightbox-counter></p>';
    document.body.appendChild(overlay);

    overlay.querySelectorAll('[data-vibee-lightbox-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    overlay.querySelector('[data-vibee-lightbox-prev]').addEventListener('click', function () {
      show(activeIndex - 1);
    });
    overlay.querySelector('[data-vibee-lightbox-next]').addEventListener('click', function () {
      show(activeIndex + 1);
    });

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    var touchStartX = 0;
    overlay.addEventListener(
      'touchstart',
      function (e) {
        touchStartX = e.changedTouches[0].clientX;
      },
      { passive: true },
    );
    overlay.addEventListener(
      'touchend',
      function (e) {
        var delta = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(delta) < 40) return;
        if (delta < 0) show(activeIndex + 1);
        else show(activeIndex - 1);
      },
      { passive: true },
    );

    document.addEventListener('keydown', function (e) {
      if (overlay.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(activeIndex - 1);
      if (e.key === 'ArrowRight') show(activeIndex + 1);
    });

    return overlay;
  }

  function trapFocus(root) {
    var closeBtn = root.querySelector('.vibee-lightbox__close');
    var focusables = root.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    );
    focusables = Array.prototype.slice.call(focusables).filter(function (el) {
      return !el.disabled;
    });

    function onKeyDown(e) {
      if (e.key !== 'Tab' || !focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    root.addEventListener('keydown', onKeyDown);
    if (closeBtn) closeBtn.focus();

    return function () {
      root.removeEventListener('keydown', onKeyDown);
    };
  }

  function imageItems(list) {
    return list.filter(function (item) {
      return item && item.type !== 'video' && item.src;
    });
  }

  function show(index) {
    var images = imageItems(items);
    if (!images.length) return;
    if (index < 0) index = images.length - 1;
    if (index >= images.length) index = 0;
    activeIndex = index;

    var item = images[index];
    var img = overlay.querySelector('.vibee-lightbox__image');
    var counter = overlay.querySelector('[data-vibee-lightbox-counter]');
    img.src = item.src || item.src1200;
    img.alt = item.alt || '';
    counter.textContent = index + 1 + '/' + images.length;
  }

  function open(list, startIndex) {
    items = imageItems(list || []);
    if (!items.length) return;

    buildOverlay();
    var mappedIndex = 0;
    var imageOnly = imageItems(list || []);
    var target = list[startIndex];
    if (target && target.type !== 'video') {
      for (var i = 0; i < imageOnly.length; i += 1) {
        if (imageOnly[i].id === target.id) mappedIndex = i;
      }
    }

    items = imageOnly;
    overlay.hidden = false;
    overlay.classList.add('is-open');
    lockScroll(true);
    show(mappedIndex);
    if (focusTrapCleanup) focusTrapCleanup();
    focusTrapCleanup = trapFocus(overlay);
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.hidden = true;
    lockScroll(false);
    if (focusTrapCleanup) {
      focusTrapCleanup();
      focusTrapCleanup = null;
    }
  }

  window.VibeeLightbox = { open: open, close: close };
})();
